goog.provide("shadow.js.shim.module$ol$tilegrid$WMTS");
goog.provide("module$shadow_js_shim_module$ol$tilegrid$WMTS");
shadow.js.shim.module$ol$tilegrid$WMTS = shadow.js.nativeProvides["ol/tilegrid/WMTS"] = shadow$bridge("ol/tilegrid/WMTS");
module$shadow_js_shim_module$ol$tilegrid$WMTS.default = shadow.js.shim.module$ol$tilegrid$WMTS;
